import { useRef, useEffect, useState } from 'react'

import { SidebarContent } from './SidebarContent'
import type { CompanySidebarHeader, SidebarTabConfig } from './index'

interface CompanySidebarOldProps {
  chainProxyId: number
  header: CompanySidebarHeader
  tabs: SidebarTabConfig[]
  doorId?: number
  address?: string
  phone?: string
}

/**
 * Original sidebar for old navigation - sticky with calculated height.
 * @deprecated Delete when old nav is removed. See TODO in NewCompanyPage/index.tsx
 */
export function CompanySidebarOld(props: CompanySidebarOldProps) {
  const sidebarRef = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState<string>('auto')

  // Calculate sidebar height based on container dimensions
  useEffect(() => {
    const scrollContainer = document.getElementById('app-content-container')
    const STICKY_TOP = 16 // matches top-4 (16px)
    const BOTTOM_PADDING = 16

    const calculateHeight = () => {
      const containerRect = scrollContainer?.getBoundingClientRect()

      if (containerRect) {
        const availableHeight =
          containerRect.height - STICKY_TOP - BOTTOM_PADDING
        setHeight(`${availableHeight}px`)
      } else {
        const availableHeight =
          window.innerHeight - 80 - STICKY_TOP - BOTTOM_PADDING
        setHeight(`${availableHeight}px`)
      }
    }

    calculateHeight()
    window.addEventListener('resize', calculateHeight)

    return () => {
      window.removeEventListener('resize', calculateHeight)
    }
  }, [])

  return (
    <div
      ref={sidebarRef}
      className="bg-white rounded-lg border border-gray-200 shadow-sm w-[360px] sticky top-4 self-start flex-shrink-0"
    >
      <div
        className="p-[20px] w-[360px] flex flex-col relative"
        style={{ height }}
      >
        <SidebarContent {...props} />
      </div>
    </div>
  )
}
